module.exports = __webpack_public_path__ + "img/selo_100-seguro-retina.f759d97.png";